import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';
import ChatLayout from 'layout/ChatLayout';

const Chat = Loadable(lazy(() => import('views/Chat')));

// ==============================|| CHAT ROUTING ||============================== //

const ChatRoutes = {
  path: '/chat',
  element: <ChatLayout />,
  children: [
    {
      path: '',
      element: <Chat />
    }
  ]
};

export default ChatRoutes;
